import { getParametersNature, getParametersType } from 'referencial/util/ReferencialUtils'
import ReferencialDto from '../../../dto/ReferencialDto'

export default class ParameterItem extends ReferencialDto {
    constructor(object) {
        super(object)
        this.id = object.code
        this.name = object.name
        this.type = getParametersType()[parseInt(object.nature)]
        this.status = object.status
        this.active = object.active
        this.nature = getParametersNature()[parseInt(object.typeParam)]
        this.casCode = object.casCode || ''
        this.SISEeaucode = object.siseCode || ''
        this.ld = object.ld
        this.lq = object.lq
        this.color = object.active === '0' && 'grey lighten-2'
        this.headers = ['code', 'name', 'type', 'nature', 'casCode', 'SISEeaucode', 'status', 'ld', 'lq']
    }
}